import React from 'react'
import { Box, Flex } from '@chakra-ui/core'
import { SkeletonBlock } from 'components/NewTaskDashboard/common'

// Sized to match NotificationRow's real footprint so nothing shifts once data lands.
export const NotificationRowSkeleton: React.FC = () => (
  <Flex p="13px 12px" minH="86px" alignItems="center" style={{ columnGap: '11px' }}>
    <SkeletonBlock h="52px" w="52px" borderRadius="999px" />
    <Box flex="1" minW="0">
      <SkeletonBlock h="13px" w="58%" borderRadius="4px" />
      <SkeletonBlock h="11px" w="85%" borderRadius="4px" mt="8px" />
      <SkeletonBlock h="11px" w="120px" borderRadius="4px" mt="8px" />
    </Box>
  </Flex>
)
